var layout_default = {
  "layout": "bk5ee",
  "cell": "UmcDW"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
